import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "material-icons-font/material-icons-font.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, AuthProvider, configureNaniClub, consumeNaniClubTokenFromUrl } from "common-components";
import { ConfigProvider } from "antd";
import "antd/dist/antd.css";
import zhTW from "antd/lib/locale/zh_TW";
import "./index.css";

const { Provider } = AuthProvider;
const root = document.getElementById("root");
const Main = () => (
	<Provider apiBaseUrl={process.env.REACT_APP_RESOURCE_PLATFORM_DOMAIN} productApiUrl={process.env.REACT_APP_DOMAIN}>
		<ThemeProvider>
			<BrowserRouter>
				<ConfigProvider locale={zhTW}>
					<App />
				</ConfigProvider>
			</BrowserRouter>
		</ThemeProvider>
	</Provider>
);

configureNaniClub({
	apiUrl: process.env.REACT_APP_NANI_CLUB_API,
	clientId: process.env.REACT_APP_NANI_CLUB_OIDC_CLIENT_ID,
});

// Nani Club 會把使用者導回 ?token=<JWT>，要在 AuthProvider 掛載前寫進 cookie，
// AuthMachine 啟動時才判斷得到已登入。
try {
	consumeNaniClubTokenFromUrl();
} catch (error) {
	// 消化失敗就當作沒登入，由落點頁顯示錯誤，不要擋住整個 app 的 render
	// eslint-disable-next-line no-console
	console.error("[naniClub] consume token failed", error);
}

ReactDOM.render(Main(), root);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
